export default [
    {
        path: '/rent/v2/time',
        name: 'time',
        component: () => import('@/pages/choose/time'),
        meta: { title: '租车时间', requireAuth: true },
    },
    {
        path: '/rent/v2/vehicleType',
        name: 'vehicleType',
        component: () => import('@/pages/choose/vehicleType'),
        meta: { title: '选择车型', requireAuth: true },
    },
    {
        path: '/rent/v2/modify',
        name: 'modify',
        component: () => import('@/pages/choose/modify'),
        meta: { title: '修改取换车条件', requireAuth: true },
    },
]


// WEBPACK FOOTER //
// ./src/pages/choose/choose.js